<!-- 数据曲线 -->
<template>
    <div class="chart" id="container" ref="chart"></div>
</template>

<script>
/**
 * 用于显示实时曲线
 */
import echarts from 'echarts'
import { Area, Line } from '@antv/g2plot';
import { get } from "@/utils/http";
import { forEach, find } from "lodash"
import { objectToParams } from '@/utils/util.js'
import { soilParamList } from '@/utils/config.js'
import { formatDate } from '@/common/util.js'
export default {
    name: 'multichart',
    data() {
        return {
            nodeids: '',
            chart: null,
            option: null,
            node: null,
            interval: null,
            labels: [],
            series: [],
            lineColor: [
                'rgba(69, 172, 248, 1)',
                'rgba(52, 172, 123, 1)',
                'rgba(208, 126, 132, 1)',
                'rgba(162, 96, 226, 1)'
            ]
        }
    },
    destroyed() {
        if (this.interval) {
            clearInterval(this.interval)
        }
    },
    methods: {
        loadData(begin, end, key, queryName, valueParamList) {
            const param = {
                // key:2304270013,
                key: key,
                metrics: queryName,
                begin: begin,
                end: end,
            };
            get(`/metrics/list?${objectToParams(param)}`).then(res => {
                if (res.data) {
                    if (res.data) {
                        let temp = [];
                        let unit = "";
                        forEach(res.data.rows, (item, index) => {
                            for (var key in item) {
                                if (valueParamList.indexOf(key) !== -1) {
                                    const o = find(soilParamList, { key: key });
                                    if (o) {
                                        unit = o.unit;
                                        temp.push({ name: o.label, time: item.receivedAt, value: item[key], unit: o.unit });
                                    }

                                }
                            }



                        });
                        // this.dataList=temp;
                        if (this.chart) {
                            this.chart.changeData(temp);
                            this.chart.update({
                                data: temp,
                                tooltip: {
                                    formatter: (item) => {
                                        return { name: item.name, value: `${item.value}${unit}` }
                                    }
                                },
                            })

                        } else {
                            const plot = new Line('container', {
                                data: temp,
                                isGroup: true,
                                xField: 'time',
                                yField: 'value',
                                seriesField: 'name',
                                interactions: [{ type: 'element-selected' }],
                                tooltip: {
                                    formatter: (item) => {

                                        return { name: item.name, value: `${item.value}${unit}` }
                                    }
                                },
                            });
                            this.chart = plot;
                            plot.render();
                        }

                        // this.node = 'dsff'

                        // this.initOption()
                        //  this.chart.setOption(this.option)
                    } else {
                        // this.chart.hideLoading()
                    }

                }

            }).catch(error => {
                if (this.chart) {
                    this.chart.changeData([]);
                    this.chart.update({
                        data: [],
                    })
                }

            })
            return;
            this.nodeids = nodeids
            if (!this.chart) {
                this.chart = echarts.init(this.$refs.chart)
            }
            this.chart.clear()
            this.chart.showLoading()
            // 加载设备的数据
            this.$request('history', 'shangqing', {
                nodeid: this.nodeids,
                year: year,
                month: month
            }).then(res => {
                if (res.code === 1) {
                    this.labels = res.data.Category
                    let series = res.data.Series
                    series.sort((a, b) => {
                        return a.DataNode.Resource - b.DataNode.Resource
                    })
                    this.series = series
                    if (this.series.length > 0) {
                        this.node = this.series[0].DataNode
                    }
                    this.initOption()
                    this.chart.setOption(this.option)
                }
                this.chart.hideLoading()
            })
        },
        initOption() {
            this.option = {
                tooltip: {
                    trigger: 'axis',
                    formatter: params => {
                        var html = params[0].name + '<br/>'
                        params.forEach(element => {
                            html += `${element.marker} ${element.seriesName}：${element.data
                                } ${this.node.Unit || ''}<br/>`
                        })
                        return html
                    }

                    // `{b}<br/>
                    // {a0}：{c0}${
                    //     this.node.Unit
                    // }<br/>{a1}：{c1}${this.node.Unit}<br/>{a2}：{c2}${
                    //     this.node.Unit
                    // }<br/>{a3}：{c3}${this.node.Unit}`
                },
                legend: {
                    show: true,
                    x: 'center',
                    top: '0',
                    icon: 'stack',
                    itemWidth: 10,
                    itemHeight: 10,
                    textStyle: {
                        color: '#1371AE',
                        fontSize: '10'
                    },
                    data: ['20cm', '40cm', '60cm', '80cm']
                },
                grid: {
                    top: '5%',
                    bottom: '15%',
                    left: '5%',
                    right: '5%'
                },
                calculable: true,
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: this.labels,
                        axisLabel: {
                            // 坐标轴刻度标签的相关设置。
                            interval: 'auto', // 设置为 1，表示『隔一个标签显示一个标签』
                            margin: 15,
                            textStyle: {
                                color: '#4c647c',
                                fontStyle: 'normal',
                                fontSize: 12
                            },
                            formatter: function (params, index) {
                                return formatDate(params, 'MM-dd')
                            }
                        },
                        axisTick: {
                            // 坐标轴刻度相关设置。
                            show: false
                        },
                        axisLine: {
                            // 坐标轴轴线相关设置
                            lineStyle: {
                                color: '#4c647c',
                                opacity: 0.2
                            }
                        },
                        splitLine: {
                            // 坐标轴在 grid 区域中的分隔线。
                            show: false,
                            lineStyle: {
                                color: '#eaeaea'
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        splitNumber: 5,
                        // min: this.node.validlowlimit,
                        max: this.node.validhighlimit,
                        axisLabel: {
                            textStyle: {
                                color: '#4c647c',
                                fontStyle: 'normal',
                                fontSize: 12
                            }
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#eaeaea'
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '20cm',
                        type: 'line',
                        smooth: true,
                        // symbol: 'circle',
                        symbolSize: 5,
                        showSymbol: true,
                        lineStyle: {
                            normal: {
                                color: 'RGBA(162, 96, 226, 1)',
                                lineStyle: {
                                    color: 'RGBA(162, 96, 226, 1)',
                                    width: 1
                                }
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0,
                                    1,
                                    0,
                                    0,
                                    [
                                        {
                                            offset: 0,
                                            color: 'RGBA(162, 96, 226, 0)'
                                        },
                                        {
                                            offset: 1,
                                            color: 'RGBA(162, 96, 226, 0.1)'
                                        }
                                    ]
                                )
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: 'RGBA(162, 96, 226, 1)',
                                borderColor: 'RGBA(162, 96, 226, 1)',
                                borderWidth: 2
                            }
                        },
                        data:
                            this.series.length > 0 ? this.series[0].Values : []
                    },
                    {
                        name: '40cm',
                        type: 'line',
                        smooth: true,
                        // symbol: 'circle',
                        symbolSize: 5,
                        showSymbol: true,
                        lineStyle: {
                            normal: {
                                color: 'rgba(208, 126, 132, 1)',
                                lineStyle: {
                                    color: 'rgba(208, 126, 132, 1)',
                                    width: 1
                                }
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0,
                                    1,
                                    0,
                                    0,
                                    [
                                        {
                                            offset: 0,
                                            color: 'RGBA(208, 126, 132, 0)'
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(208, 126, 132, 0.1)'
                                        }
                                    ]
                                )
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: 'rgba(208, 126, 132, 1)',
                                borderColor: 'rgba(208, 126, 132, 1)',
                                borderWidth: 2
                            }
                        },
                        data:
                            this.series.length > 1 ? this.series[1].Values : []
                    },
                    {
                        name: '60cm',
                        type: 'line',
                        smooth: true,
                        // symbol: 'circle',
                        symbolSize: 5,
                        showSymbol: true,
                        lineStyle: {
                            normal: {
                                color: 'rgba(52, 172, 123, 1)',
                                lineStyle: {
                                    color: 'rgba(52, 172, 123, 1)',
                                    width: 1
                                }
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0,
                                    1,
                                    0,
                                    0,
                                    [
                                        {
                                            offset: 0,
                                            color: 'RGBA(52, 172, 123, 0)'
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(52, 172, 123, 0.1)'
                                        }
                                    ]
                                )
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: 'rgba(52, 172, 123, 1)',
                                borderColor: 'rgba(52, 172, 123, 1)',
                                borderWidth: 2
                            }
                        },
                        data:
                            this.series.length > 2 ? this.series[2].Values : []
                    },
                    {
                        name: '80cm',
                        type: 'line',
                        smooth: true,
                        // symbol: 'circle',
                        symbolSize: 5,
                        showSymbol: true,
                        lineStyle: {
                            color: 'rgba(69, 172, 248, 1)',
                            lineStyle: {
                                color: 'rgba(69, 172, 248, 1)',
                                width: 1
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0,
                                    1,
                                    0,
                                    0,
                                    [
                                        {
                                            offset: 0,
                                            color: 'RGBA(69, 172, 248, 0)'
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(69, 172, 248, 0.1)'
                                        }
                                    ]
                                )
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: 'rgba(69, 172, 248, 1)',
                                borderColor: 'rgba(69, 172, 248, 1)',
                                borderWidth: 2
                            }
                        },
                        data:
                            this.series.length > 3 ? this.series[3].Values : []
                    }
                ]
            }
        }
    }
}
</script>
<style lang='less' scoped>
.chart {
    height: 220px;
}
</style>
